import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-state-label',
  templateUrl: './state-label.component.html',
  styleUrls: ['./state-label.component.scss'],
  standalone: false,
})
export class StateLabelComponent {
  @Input() label: string;
  @Input() background:
    | 'primary'
    | 'secondary'
    | 'white'
    | 'black'
    | 'secondaryblack'
    | 'purple'
    | 'blue'
    | 'salmon'
    | 'green'
    | 'yellow'
    | 'greylightextra'
    | 'greylight'
    | 'greymedium'
    | 'grey'
    | 'greydark'
    | 'greyblue'
    | 'bggrey'
    | 'bg01'
    | 'bg02'
    | 'bgdarkopacity' = 'blue';

  @Input() color: 'white' | 'black' = 'white';
}
